/* eslint-disable import/prefer-default-export */
import { TaxIdValidation } from '../types';
import { COLOMBIA_NIT_REGEX } from './ColombiaRegex';
import {
  COMPANY_RFC_REGEX,
  GENERIC_RFC_REGEX,
  PERSON_RFC_REGEX,
} from './MexicoRegex';
import { USA_TIN_REGEX } from './UsaRegex';

/**
 * Mapping of tax identification validation types to their corresponding regex patterns.
 *
 * This object helps in selecting the appropriate regex based on the type of tax ID that needs to be validated.
 * It supports various formats including RFCs for Mexico, TIN for the USA, and NIT for Colombia.
 *
 * @constant
 * @type {Record<TaxIdValidation, RegExp>}
 * @property {RegExp} [TaxIdValidation.GENERIC] - Generic RFC validation regex for Mexico.
 * @property {RegExp} [TaxIdValidation.COMPANY] - RFC validation regex for companies (legal entities) in Mexico.
 * @property {RegExp} [TaxIdValidation.PERSON] - RFC validation regex for individuals (natural persons) in Mexico.
 * @property {RegExp} [TaxIdValidation.USA] - TIN validation regex for the USA, which includes SSN and EIN formats.
 * @property {RegExp} [TaxIdValidation.COLOMBIA] - NIT validation regex for Colombia.
 */
export const TAX_VALIDATION = {
  [TaxIdValidation.GENERIC]: GENERIC_RFC_REGEX, // Generic RFC validation for Mexico
  [TaxIdValidation.COMPANY]: COMPANY_RFC_REGEX, // RFC validation for companies in Mexico
  [TaxIdValidation.PERSON]: PERSON_RFC_REGEX, // RFC validation for individuals in Mexico
  [TaxIdValidation.USA]: USA_TIN_REGEX, // TIN validation for the USA
  [TaxIdValidation.COLOMBIA]: COLOMBIA_NIT_REGEX, // NIT validation for Colombia
};
